import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { piIconHelpBold } from '@predictiveindex/pi-client-icons';
import {
    TapestryIconComponent,
    TapestryIconModule,
    TapestryIconRegistryService,
    TapestrySelectModule,
    TapestrySidenavModule,
    TapestryNotificationService
} from '@predictiveindex/tapestry';
import { UserTypeaheadModule } from '../core-ui';
import { CoreUiModule, UserGridModule } from '../core-ui';
import { MyProfileTooltipModule } from '../my-profile-tooltip';
import { ThirdPartyModule } from '../third-party-table';
import { HelpLinkComponent } from './help-link.component';
import { ModuleUserManagementPageComponent } from './module-user-management-page';
import { AccessLevelHeaderTooltipComponent } from './module-user-management-tab/access-level-header-tooltip/access-level-header-tooltip.component';
import { HeaderWithIconComponent } from './module-user-management-tab/header-with-icon/header-with-icon.component';
import { ModuleUserManagementComponent } from './module-user-management-tab/module-user-management-grid/module-user-management-grid.component';
import { ModuleUserManagementInvitationComponent } from './module-user-management-tab/module-user-management-invitation/module-user-management-invitation.component';
import { ModuleUserManagementTabComponent } from './module-user-management-tab/module-user-management-tab.component';
import { CompanyDropdownComponent } from './pi-company-dropdown.component';
import { HeaderComponent } from './pi-header.component';
import { PendoDropdownComponent } from './pi-pendo-dropdown.component';
import { SearchComponent } from './pi-search.component';
import { TranslationDropdownComponent } from './pi-translation-dropdown.component';
import { ResendInviteCellRendererComponent } from './resend-invite-cell-renderer.component';
import { UserDropdownComponent } from './user-dropdown.component';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreUiModule,
        MyProfileTooltipModule,
        TapestrySidenavModule,
        UserGridModule,
        MatDividerModule,
        MatTabsModule,
        MatFormFieldModule,
        MatSnackBarModule,
        ThirdPartyModule,
        UserTypeaheadModule,
        TapestrySelectModule,
        RouterModule,
        TapestryIconModule
    ],
    declarations: [
        HeaderComponent,
        HelpLinkComponent,
        TranslationDropdownComponent,
        PendoDropdownComponent,
        UserDropdownComponent,
        SearchComponent,
        CompanyDropdownComponent,
        ModuleUserManagementComponent,
        ModuleUserManagementPageComponent,
        ModuleUserManagementInvitationComponent,
        ModuleUserManagementTabComponent,
        ResendInviteCellRendererComponent,
        AccessLevelHeaderTooltipComponent,
        HeaderWithIconComponent
    ],
    exports: [
        HeaderComponent,
        CompanyDropdownComponent,
        HeaderWithIconComponent,
        TapestryIconComponent
    ],
    providers: [TapestryNotificationService]
})
export class HeaderModule {
    constructor(private iconRegistryService: TapestryIconRegistryService) {
        iconRegistryService.registerIcons([piIconHelpBold]);
    }
}
